var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    className: "list_svg__bi list_svg__bi-list",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 13.5A.5.5 0 0 1 5 13h10a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5m0-4A.5.5 0 0 1 5 9h10a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5m0-4A.5.5 0 0 1 5 5h10a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};
export default SvgList;